import React from "react";
import { Image } from "react-bootstrap";

// Example: Customising The Header Decorator To Include Icons
const Toggle = ({ onClick, style, node }) => {
  return (
    <div className={`toggle_icon ${node.toggled ? ' down':' '}`} onClick={onClick}>
      <Image src="/dashboard/asset/icons/drupdownIconDown.svg" className="icon" />
    </div>
  );
};

export default Toggle;
